var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScore5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.522426 9.16501V7.04101H6.08443V9.16501H0.522426ZM11.81 13.377C10.934 13.377 10.142 13.191 9.43397 12.819C8.72597 12.435 8.13797 11.883 7.66997 11.163L8.96597 9.75901C9.49397 10.347 9.96797 10.755 10.388 10.983C10.808 11.199 11.27 11.307 11.774 11.307C12.23 11.307 12.638 11.211 12.998 11.019C13.358 10.815 13.646 10.545 13.862 10.209C14.078 9.86101 14.186 9.48301 14.186 9.07501C14.186 8.63101 14.084 8.24101 13.88 7.90501C13.676 7.55701 13.4 7.28101 13.052 7.07701C12.704 6.87301 12.308 6.77101 11.864 6.77101C11.624 6.77101 11.396 6.78901 11.18 6.82501C10.964 6.86101 10.712 6.93301 10.424 7.04101C10.148 7.14901 9.79397 7.31701 9.36197 7.54501L8.24597 6.03301L8.98397 0.615007H15.95V2.68501H10.298L10.82 2.10901L10.226 6.10501L9.55997 5.63701C9.71597 5.49301 9.94397 5.35501 10.244 5.22301C10.556 5.09101 10.892 4.98301 11.252 4.89901C11.612 4.81501 11.966 4.77301 12.314 4.77301C13.094 4.77301 13.79 4.95301 14.402 5.31301C15.014 5.67301 15.5 6.17101 15.86 6.80701C16.22 7.43101 16.4 8.15101 16.4 8.96701C16.4 9.79501 16.196 10.545 15.788 11.217C15.392 11.877 14.846 12.405 14.15 12.801C13.454 13.185 12.674 13.377 11.81 13.377Z",
    fill: "#02AA27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore5);
export default __webpack_public_path__ + "static/media/score5.9c7d4d9c8ac7785cef4dab02b3ce7a59.svg";
export { ForwardRef as ReactComponent };